import config from 'config';
import { http_client } from './api';

const harga = async (
  student_type_id = null,
  subscription_type_id = null,
  class_type_id = null,
  school_type_id = null,
  tahun_ajaran_id = null,
  jenjang_id = null,
  cabang_id = null
) => {
  return http_client
    .get(
      config.baseApiUrl +
        'api/harga?' +
        `${student_type_id ? '&student_type_id=' + student_type_id : ''}` +
        `${subscription_type_id ? '&subscription_type_id=' + subscription_type_id : ''}` +
        `${class_type_id ? '&class_type_id=' + class_type_id : ''}` +
        `${school_type_id ? '&school_type_id=' + school_type_id : ''}` +
        `${tahun_ajaran_id ? '&tahun_ajaran_id=' + tahun_ajaran_id : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${cabang_id ? '&cabang_id=' + cabang_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const user = async (type = 'all', page = null, perPage = null, sort = null, orderBy = null, search = null) => {
  return http_client
    .get(
      config.baseApiUrl +
        'api/user?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${type ? '&type=' + type : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const student = async (page = null, perPage = null, sort = null, orderBy = null, search = null, jenjang_id = null, sekolah_id = null) => {
  return http_client
    .get(
      config.baseApiUrl +
        'api/student?' +
        `${perPage ? 'perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `${jenjang_id ? '&jenjang_id=' + jenjang_id : ''}` +
        `${sekolah_id ? '&sekolah_id=' + sekolah_id : ''}`
    )
    .then((response) => {
      return response.data;
    });
};

const tahunajaran = async () => {
  return http_client.get(config.baseApiUrl + 'api/tahunajaran').then((response) => {
    return response.data;
  });
};

const sekolah = async (jenjang) => {
  return http_client.get(config.baseApiUrl + 'api/sekolah/' + jenjang).then((response) => {
    return response.data;
  });
};

const cabang = async () => {
  return http_client.get(config.baseApiUrl + 'api/cabang').then((response) => {
    return response.data;
  });
};

const jenjang = async () => {
  return http_client.get(config.baseApiUrl + 'api/jenjang').then((response) => {
    return response.data;
  });
};

const mapel = async (jenjangID) => {
  return http_client.get(config.baseApiUrl + 'api/mapel/' + jenjangID).then((response) => {
    return response.data;
  });
};

const bab = async (mapelID) => {
  return http_client.get(config.baseApiUrl + 'api/bab/' + mapelID).then((response) => {
    return response.data;
  });
};

const subbab = async (babID) => {
  return http_client.get(config.baseApiUrl + 'api/subbab/' + babID).then((response) => {
    return response.data;
  });
};

const studentType = async () => {
  return http_client.get(config.baseApiUrl + 'api/student-type').then((response) => {
    return response.data;
  });
};

const subscriptionType = async () => {
  return http_client.get(config.baseApiUrl + 'api/subscription-type').then((response) => {
    return response.data;
  });
};

const classType = async () => {
  return http_client.get(config.baseApiUrl + 'api/class-type').then((response) => {
    return response.data;
  });
};

const schoolType = async () => {
  return http_client.get(config.baseApiUrl + 'api/school-type').then((response) => {
    return response.data;
  });
};

const examType = async () => {
  return http_client.get(config.baseApiUrl + 'api/exam-type').then((response) => {
    return response.data;
  });
};

const masterFilter = async () => {
  return http_client.get(config.baseApiUrl + 'api/master').then((response) => {
    return response.data;
  });
};

const getBase64File = async (data) => {
  return http_client.post(config.baseApiUrl + 'api/base64', data).then((response) => {
    return response.data;
  });
};

const getWeekDay = async () => {
  return http_client.get(config.baseApiUrl + 'api/weekday').then((response) => {
    return response.data;
  });
};

const studentByMapel = async (
  mapelId,
  cabang = null,
  classType = null,
  page = null,
  perPage = null,
  sort = null,
  orderBy = null,
  search = null
) => {
  return http_client
    .get(
      config.baseApiUrl +
        'api/student/' +
        mapelId +
        '?' +
        `${cabang ? '&cabang_id=' + cabang : ''}` +
        `${classType ? '&class_type_id=' + classType : ''}` +
        `${perPage ? '&perPage=' + perPage : ''}` +
        `${page ? '&page=' + page : ''}` +
        `${orderBy ? '&orderBy=' + orderBy : ''}` +
        `${sort ? '&sort=' + sort : ''}` +
        `${search ? '&search=' + search : ''}` +
        `&status=active`
    )
    .then((response) => {
      return response.data;
    });
};

const CabangService = {
  harga,
  user,
  student,
  tahunajaran,
  sekolah,
  cabang,
  jenjang,
  mapel,
  bab,
  subbab,
  studentType,
  subscriptionType,
  classType,
  schoolType,
  examType,
  masterFilter,
  getBase64File,
  studentByMapel,
  getWeekDay
};

export default CabangService;
